import React, { useState, useCallback } from 'react';

export default function useToggle(initialValue = false) {
    const [value, setValue] = useState(initialValue);

    const toggle = useCallback(() => {
        setValue(v => !v);
    }, []);
    return [value, toggle];
}